import { Apple, CircleHelp, PanelsTopLeft, Terminal } from 'lucide-react'

export const isMacPlatform = platform => {
  const value = (platform || '').toLowerCase()

  return value.startsWith('darwin') || value.includes('macos')
}

export const isWindowsPlatform = platform => {
  const value = (platform || '').toLowerCase()

  return value.startsWith('win') || value.includes('windows')
}

export const getPlatformDisplay = platform => {
  const value = (platform || '').toLowerCase()

  if (isMacPlatform(value)) {
    return { icon: Apple, label: 'macOS' }
  }

  if (value.includes('linux')) {
    return { icon: Terminal, label: 'Linux' }
  }

  if (isWindowsPlatform(value)) {
    return { detail: platform, icon: PanelsTopLeft, label: 'Windows' }
  }

  return { icon: CircleHelp, label: 'Unknown' }
}
